/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, useEstetica } from "../../shared";
import { Formulario } from "../../shared";
import logoVerticalBlanco from "../../images/logoVerticalBlanco.png";

import { Toast } from "primereact/toast";
import { Card } from "primereact/card";

export default function SolicitudCambioPassword() {
  const estetica = useEstetica();
  const [loginFormLoader, setLoginFormLoader] = useState(false);
  const [mostrarAviso, setMostrarAviso] = useState(false);

  const navigate = useNavigate();

  const toast = useRef(null);
  // Configuración del formulario de login
  const loginFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "email",
            tipoitemformularioid: 2,
            etiqueta: "Email",
            requerido: true,
          },
        ],
      },
    ],
    botones: [
      {
        etiqueta: "Solicitar cambio",
        callback: solicitarCambio,
        validar: true,
      },
      {
        etiqueta: "Cancelar",
        transparente: true,
        callback: () => {
          navigate("/");
        },
      },
    ],
  };

  // Submit del email
  function solicitarCambio(contenidoCampos) {
    setLoginFormLoader(true);
    accessAPI(
      "POST",
      "recuperarPassword",
      contenidoCampos,
      () => {
        setLoginFormLoader(false);
        setMostrarAviso(true);
      },
      (response) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            response[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true,
        });
        setLoginFormLoader(false);
      },
    );
  }

  return (
    <main
      css={{
        paddingBottom: "50px",
        minHeight: "calc(100vh - var(--alturaFooter))",
      }}
    >
      <Toast ref={toast} position="top-center" />

      <div
        css={{
          paddingTop: "50px",
          marginBottom: "30px",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <img
          css={{
            width: "150px",
            marginLeft: "auto",
            marginRight: "auto",
            display: "block",
          }}
          // El logo en blanco del organismo; si no cargó uno, el de la
          // plataforma.
          src={estetica?.logos?.blanco || logoVerticalBlanco}
          alt="logo"
        />
      </div>
      <Card
        css={{
          width: "400px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {!mostrarAviso ? (
          <div>
            <h1>
              Ingrese su email y recibirá un link para el reinicio de contraseña
            </h1>
            <Formulario
              config={loginFormConfig}
              loader={loginFormLoader}
              formularioEnCuerpo
            />
          </div>
        ) : (
          <div>
            <p>
              En unos instantes recibirá un correo electrónico con instrucciones
              para actualizar su contraseña. Por favor verifique su carpeta de
              Spam.
            </p>
            <p>Si no le llegara, no dude en contactarse con nosotros.</p>
          </div>
        )}
      </Card>
    </main>
  );
}
